import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackCancelQuickOrderListUploadParameters extends TrackEventBaseParameters {}

const trackCancelQuickOrderListUpload = (
    parameters: TrackCancelQuickOrderListUploadParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "cancel_quick_order_list_upload", ...parameters }, options);
};

export default trackCancelQuickOrderListUpload;
